import { action, makeObservable, observable } from 'mobx'
import { v4 as uuid } from 'uuid'
import { routeMessage } from '@migrate/utils/common'
import i18next, { ParseKeys, TOptions } from 'i18next'
import UserNotifiableError from '@migrate/components/shared/type/UserNotifiableError'
import { OptionsObject } from 'notistack'
import LoadableStore from '@migrate/stores/LoadableStore'

export enum UserNotificationType {
  DEFAULT,
  ERROR,
  WARNING,
  INFO,
  SUCCESS,
}

export interface IUserNotification {
  key: string
  type: UserNotificationType
  messageCode: string
  additionalOptions?: {
    messageOptions?: TOptions
    notifierOptions?: OptionsObject
  }
  details?: any
}

export default class UserNotificationStore extends LoadableStore {
  public static STORE_NAME = 'userNotificationStore'

  @observable public notifications: IUserNotification[]

  constructor() {
    super()
    this.notifications = []
    makeObservable(this)
  }

  @action
  public addNotification(
    type: UserNotificationType,
    messageCode: string,
    additionalOptions?: IUserNotification['additionalOptions'],
  ) {
    if (window.parent !== window.self) {
      let topic = 'toastInfo'
      // FIXME: i18next upgrade
      const message = i18next.t(messageCode as ParseKeys, additionalOptions?.messageOptions)
      switch (type) {
        case UserNotificationType.SUCCESS:
          topic = 'toastSuccess'
          break
        case UserNotificationType.ERROR:
          topic = 'toastError'
          break
        case UserNotificationType.WARNING:
          topic = 'toastWarning'
          break
      }
      routeMessage(topic, message, () => {}, additionalOptions?.notifierOptions)
    } else {
      this.notifications.push({ key: uuid(), type, messageCode, additionalOptions })
    }
  }

  public addNotificationFromError({
    messageCode,
    messageOptions,
    notificationType,
  }: UserNotifiableError) {
    this.addNotification(notificationType, messageCode, { messageOptions })
  }

  public load(): Promise<void> {
    return Promise.resolve()
  }

  async unload(): Promise<void> {
    this.notifications = []
  }
}
